import pb from "../../../lib/pocketbase"
import classes from "../Backup/Backup.module.css"
import { useTranslation } from "react-i18next"
import { faUpload, faDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useLocalStorage } from "../../../Utils"
import { dict_length, get_full_data_struct, decrypt_key } from "../../../Utils"
import { useEffect, useState } from "react"
import { defaultGearList, defaultImportData, defaultProfile } from "../../../DefaultEntries"

const OnlineSync = props => {
    const { t } = useTranslation()
    const [currentData, setCurrentData] = useState(pb.authStore.model.database ?? {})
    const [, setGearList] = useLocalStorage("gearList", defaultGearList)
    const [, setUserData] = useLocalStorage("importData", defaultImportData)
    const [, setProfileData] = useLocalStorage("profile", defaultProfile)

    useEffect(() => {
        if (!pb.authStore.isValid) return
        pb.collection("users").authRefresh()
    }, [])

    const onOpen = () => {
        pb.collection("users")
            .update(pb.authStore.model.id, { database: get_full_data_struct() })
            .then(new_data => {
                setCurrentData(new_data.database)
                alert(t("misc:Database.SuccessfullySynchronizedWithServer"))
            })
    }
    const onDownload = () => {
        if (!window.confirm(t("misc:Database.ReplaceDatabaseConfirmation"))) return
        setGearList(currentData.GearDB ?? defaultGearList)
        setUserData(currentData.UserData ?? defaultImportData)
        setProfileData(currentData.Profile ?? defaultProfile)
        props.rerender(v => !v)
        alert(t("misc:Database.SuccessfullySynchronizedWithClient"))
    }
    const gearList = currentData.GearDB ?? defaultGearList
    return (
        <>
            <div className={classes.cardWrapperWrapper}>
                <div className={classes.cardWrapper}>
                    <div className={classes.Subtitle}>
                        <h6 className={classes.Subtitleh6}>{t("misc:Database.SynchronizeDatabase")}</h6>
                    </div>
                    <hr className={classes.Divider} />
                    <div className={classes.CardContent}>
                        <div className={classes.CardDark}>
                            <div>
                                <div>
                                    <p>
                                        <strong>{t("misc:Database.OnlineDatabaseContent")}:</strong>
                                    </p>
                                    <p className={classes.TextDescription}>
                                        {t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnCategory_01-T_Category_00")}:{" "}
                                        <strong>{dict_length(gearList.HaveGearHeadMap)}</strong>
                                    </p>
                                    <p className={classes.TextDescription}>
                                        {t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnCategory_02-T_Category_00")}:{" "}
                                        <strong>{dict_length(gearList.HaveGearClothesMap)}</strong>
                                    </p>
                                    <p className={classes.TextDescription}>
                                        {t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnCategory_03-T_Category_00")}:{" "}
                                        <strong>{dict_length(gearList.HaveGearShoesMap)}</strong>
                                    </p>
                                    <p className={classes.TextDescription}>
                                        {t("misc:Common.SeedKey")}:{" "}
                                        <strong>
                                            {(currentData.UserData ?? {}).UserKey &&
                                            decrypt_key(currentData.UserData.UserKey, currentData.UserData.H) !== 0
                                                ? t("misc:Common.SeedKeyValid")
                                                : t("misc:Common.SeedKeyNotSet")}
                                        </strong>
                                    </p>
                                    <p className={classes.TextDescription}>
                                        {t("misc:Database.LastUpdated")}:{" "}
                                        <strong>{new Date(currentData.LastUpdated).toString()}</strong>
                                    </p>
                                </div>
                                <div style={{ marginTop: 16 }}>
                                    <div className={classes.GridStyle}>
                                        <div className={classes.GridElem}>
                                            <button onClick={onOpen} className={classes.ButtonInfo}>
                                                <FontAwesomeIcon icon={faUpload} />{" "}
                                                <span style={{ padding: 6 }}>{t("misc:Common.Upload")}</span>
                                            </button>
                                        </div>
                                        <div className={classes.GridElem}>
                                            <button
                                                onClick={onDownload}
                                                className={classes.ButtonDefault}
                                                disabled={!currentData.LastUpdated}
                                            >
                                                <FontAwesomeIcon icon={faDownload} />{" "}
                                                <span style={{ padding: 6 }}>{t("misc:Common.Download")}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OnlineSync
